module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4jIsiK/tc-custom/9781609453718.jpg?1726617332079",
      "alt": "This image is the cover for the book Beach at Night"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beach at Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A “beautifully written” dark fable from a doll’s point of view—by the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("The Lost Daughter")]), _vm._v(" and the Neapolitan Novels ("), _c('i', [_vm._v("The Washington Post")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("One of NPR’s Best Books of the Year.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Readers of Elena Ferrante’s "), _c('i', [_vm._v("The Lost Daughter")]), _vm._v(" may recall the little doll—lost or stolen—around which that novel revolves. Here, Ferrante retells the tale from the doll’s perspective."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Celina is having a terrible night, one full of jealousy for the new kitten, Minù; feelings of abandonment and sadness; misadventures at the hands of the beach attendant; and dark dreams. But she will be happily found by Mati, her child, once the sun rises . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Everyone should read anything with Ferrante’s name on it.” —"), _c('i', [_vm._v("The Boston Globe")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elena Ferrante, Mara Cerri, Ann Goldstein\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0